import React, {Suspense} from 'react'
import {useNavigate, useParams} from 'react-router-dom'
import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Select from '@mui/material/Select'

import {IDoc} from 'src/models/doc'

interface IEditorial {
  doc: IDoc
  lastEdition?: string
}

interface IEditorialData {
  editionCode: number
  id: number
  nameKyr: string
  nameRus: string
}

export const Editorial = ({doc, lastEdition}: IEditorial) => {
  const navigate = useNavigate()
  const {lang} = useParams()
  const {id: docId, redaction} = useParams()
  // const [editionCode, setEditionCode] = React.useState<string>('')
  const editionCode = localStorage.getItem('editionCode')

  const handleChangeEditorial = (id: string) => {
    localStorage.setItem('editionCode', id)
    // setEditionCode(id)
    navigate({pathname: `/${docId}/edition/${id}/${lang}`}, {replace: false, state: {exact: true}})
  }

  return (
    <Suspense fallback={null}>

    <FormControl sx={{minWidth: 120}} size='small'>
      <InputLabel shrink>Редакция</InputLabel>
      <Select
        value={lastEdition ?? String(doc?.editions[doc.editions.length - 1]?.id)}
        displayEmpty
        label='Редакция'
        notched
        onChange={(e) => handleChangeEditorial(e.target.value)}
      >
        {!doc
          ? null
          : doc?.editions?.map((i: IEditorialData, idx: number) => (
              <MenuItem key={idx} value={i.id}>
                {i.nameRus}
              </MenuItem>
            ))}
      </Select>
    </FormControl>
    </Suspense>
  )
}
